/**
 * Configuration module that reads from environment variables
 * with sensible defaults for development.
 */

export const config = {
  contact: {
    phone: import.meta.env.VITE_CONTACT_PHONE || '+1 (555) 123-4567',
    email: import.meta.env.VITE_CONTACT_EMAIL || 'info@freezonelogistic.com',
    address: import.meta.env.VITE_CONTACT_ADDRESS || 'Av. Industrial 123, Zona Franca',
    hoursWeekdays: import.meta.env.VITE_CONTACT_HOURS_WEEKDAYS || 'Lunes a Viernes: 8:00 AM - 6:00 PM',
    hoursSaturday: import.meta.env.VITE_CONTACT_HOURS_SATURDAY || 'Sábados: 9:00 AM - 1:00 PM',
  },
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || '',
    contactFormEndpoint: import.meta.env.VITE_CONTACT_FORM_ENDPOINT || '/api/contact',
  },
  analytics: {
    gaMeasurementId: import.meta.env.VITE_GA_MEASUREMENT_ID || '',
    plausibleDomain: import.meta.env.VITE_PLAUSIBLE_DOMAIN || '',
  },
  social: {
    linkedin: import.meta.env.VITE_SOCIAL_LINKEDIN || 'https://www.linkedin.com',
    facebook: import.meta.env.VITE_SOCIAL_FACEBOOK || 'https://www.facebook.com',
    instagram: import.meta.env.VITE_SOCIAL_INSTAGRAM || 'https://www.instagram.com',
  },
  siteUrl: import.meta.env.VITE_SITE_URL || 'https://www.freezonelogistic.com',
};
